export class CreateBonificacionRequest{
  public idTipoBonificacion?: number
  public detalle?:string
}
